import { render, staticRenderFns } from "./ListCarteiras.vue?vue&type=template&id=afb3769a"
import script from "./ListCarteiras.vue?vue&type=script&lang=js"
export * from "./ListCarteiras.vue?vue&type=script&lang=js"
import style0 from "./ListCarteiras.vue?vue&type=style&index=0&id=afb3769a&prod&lang=scss"
import style1 from "./ListCarteiras.vue?vue&type=style&index=1&id=afb3769a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports